export const defaultBundle = {
    "allTrueConditions": "Take all routes",
    "allTrueConditionsHelp": "Continue down multiple paths simultaneously.",
    "firstTrueConditions": "Take the first route that evaluates to true",
    "firstTrueConditionsHelp": "Continue down down a single path.",
    "actualSize": "Actual Size",
    "enterValue": "Enter a value",
    "enterValueOrSelectParameter": "Enter a value or set to a parameter",
    "add": "Add",
    "andPlus": "+ And",
    "orPlus": "+ Or",
    "addNewDataField": "Add new data field",
    "addNewParameter": "Add new parameter",
    "addNewResponse": "Add new response",
    "addProperty": "Add Property",
    "align": "Align",
    "alignment": "Alignment",
    "allChangesLost": "All changes will be lost!",
    "alwaysTrue": "Always true",
    "alwaysTrueDisabled": "Only one route can be unconditional.",
    "angle": "Angle",
    "apply": "Apply",
    "arc": "Arc",
    "arrange": "Arrange",
    "arrow": "Arrow",
    "arrows": "Arrows",
    "automatic": "Automatic",
    "autosize": "Autosize",
    "background": "Background",
    "backgroundColor": "Background Color",
    "backgroundImage": "Background Image",
    "basic": "Basic",
    "block": "Block",
    "blockquote": "Blockquote",
    "bold": "Bold",
    "border": "Border",
    "bottom": "Bottom",
    "bottomAlign": "Bottom Align",
    "bottomLeft": "Bottom Left",
    "bottomRight": "Bottom Right",
    "bulletedList": "Bulleted List",
    "cancel": "Cancel",
    "center": "Center",
    "change": "Change",
    "circle": "Circle",
    "classic": "Classic",
    "close": "Close",
    "condition": "Condition",
    "conditionHelp": "JavaScript expression to be evaluated to true to transition to the next task.",
    "conditionalRouting": "Conditional routing",
    "connect": "Connect",
    "connection": "Connection",
    "constrainProportions": "Constrain Proportions",
    "containsValidationErrors": "Contains validation errors",
    "copy": "Copy",
    "copyConnect": "Copy on Connect",
    "create": "Create",
    "curved": "Curved",
    "custom": "Custom",
    "cut": "Cut",
    "dashed": "Dashed",
    "decreaseIndent": "Decrease Indent",
    "default": "Default",
    "delete": "Delete",
    "description": "Description",
    "diagram": "Diagram",
    "diamond": "Diamond",
    "diamondThin": "Diamond (thin)",
    "direction": "Direction",
    "distribute": "Distribute",
    "divider": "Divider",
    "documentProperties": "Document Properties",
    "done": "Done",
    "dotted": "Dotted",
    "doubleClickOrientation": "Double click to Change Orientation",
    "drawing": "Drawing{1}",
    "drawingEmpty": "Drawing is empty",
    "drawingTooLarge": "Drawing is too large",
    "duplicate": "Duplicate",
    "duplicateIt": "Duplicate {1}",
    "east": "East",
    "enterName": "Enter Name",
    "end": "End",
    "terminationStatus": "Termination status",
    "terminationStatusCompleted": "Completed",
    "terminationStatusCompletedHelp": "Terminate workflow and mark it as completed.",
    "terminationStatusFailed": "Failed",
    "terminationStatusFailedHelp": "Terminate workflow and mark it as failed.",
    "enterParameters": "Enter parameters",
    "enterPropertyName": "Enter Property Name",
    "entityRelation": "Entity Relation",
    "error": "Error",
    "errorSavingFile": "Error saving file",
    "expression": "Expression",
    "fieldName": "Field name",
    "fieldNameMustBeUnique": "Field name already exists. Must be unique.",
    "fieldNameMustBeValid": "Must contain only letters, digits, and underscores.",
    "selectParameterType": "Select parameter type",
    "parameterType.BOOLEAN": "Boolean",
    "parameterType.NUMBER": "Number",
    "parameterType.STRING": "String",
    "parameterType.TIME": "Time",
    "gap": "Gap",
    "general": "General",
    "glass": "Glass",
    "global": "Global",
    "gradient": "Gradient",
    "gradientColor": "Color",
    "grid": "Grid",
    "gridSize": "Grid Size",
    "group": "Group",
    "guides": "Guides",
    "heading": "Heading",
    "height": "Height",
    "help": "Help",
    "hidden": "Hidden",
    "hide": "Hide",
    "hideIt": "Hide {1}",
    "home": "Home",
    "horizontal": "Horizontal",
    "horizontalFlow": "Horizontal Flow",
    "horizontalTree": "Horizontal Tree",
    "html": "HTML",
    "id": "ID",
    "image": "Image",
    "images": "Images",
    "import": "Import",
    "increaseIndent": "Increase Indent",
    "inputParameter": "Input parameter",
    "enterOrSelectParameter": "Enter a value or reference a parameter...",
    "parameters": "Parameters",
    "inputParameters": "Input parameters",
    "insert": "Insert",
    "insertHorizontalRule": "Insert Horizontal Rule",
    "insertRowAfter": "Insert Row Below",
    "insertRowBefore": "Insert Row Above",
    "invalidName": "Invalid name",
    "invalidOrMissingFile": "Invalid or missing file",
    "isometric": "Isometric",
    "italic": "Italic",
    "landscape": "Landscape",
    "laneColor": "Lanecolor",
    "layers": "Layers",
    "layout": "Layout",
    "left": "Left",
    "leftAlign": "Left Align",
    "leftToRight": "Left to Right",
    "line": "Line",
    "lineJumps": "Line jumps",
    "lineend": "Line End",
    "lineheight": "Line Height",
    "linestart": "Line Start",
    "linewidth": "Linewidth",
    "loading": "Loading",
    "manual": "Manual",
    "middle": "Middle",
    "misc": "Misc",
    "more": "More",
    "moreResults": "More Results",
    "move": "Move",
    "moveSelectionTo": "Move Selection to {1}",
    "mustHaveFieldType": "Must have a field type",
    "mustNotBeBlank": "Must not be blank",
    "name": "Name",
    "navigation": "Navigation",
    "new": "New",
    "noColor": "No Color",
    "noFiles": "No files",
    "noMoreResults": "No more results",
    "noResultsFor": "No results for '{1}'",
    "none": "None",
    "normal": "Normal",
    "north": "North",
    "numberedList": "Numbered List",
    "ok": "OK",
    "opacity": "Opacity",
    "open": "Open",
    "openArrow": "Open Arrow",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "options": "Options",
    "organic": "Organic",
    "orthogonal": "Orthogonal",
    "outline": "Outline",
    "outputParameters": "Output parameters",
    "oval": "Oval",
    "parameter": "Parameter",
    "parameterName": "Parameter name",
    "pageScale": "Page Scale",
    "pageSetup": "Page Setup",
    "fork": "Fork",
    "join": "Join",
    "pageView": "Page View",
    "pages": "Pages",
    "panTooltip": "Space+Drag to Scroll",
    "paperSize": "Paper Size",
    "paste": "Paste",
    "pasteHere": "Paste Here",
    "pattern": "Pattern",
    "perimeter": "Perimeter",
    "plusTooltip": "Drag to connect",
    "portrait": "Portrait",
    "position": "Position",
    "posterPrint": "Poster Print",
    "preview": "Preview",
    "print": "Print",
    "radialTree": "Radial Tree",
    "redo": "Redo",
    "removeFormat": "Clear Formatting",
    "removeIt": "Remove {1}",
    "rename": "Rename",
    "renameIt": "Rename {1}",
    "replace": "Replace",
    "replaceExistingDrawing": "Replace existing drawing",
    "replaceIt": "{1} already exists. Do you want to replace it?",
    "reset": "Reset",
    "resetView": "Reset View",
    "responseName": "Response name",
    "responseNameMustBeUnique": "Response name already exists. Must be unique.",
    "reverse": "Reverse",
    "right": "Right",
    "rightAlign": "Right Align",
    "rightToLeft": "Right to Left",
    "rotate": "Rotate",
    "rotateTooltip": "Click and drag to rotate, click to turn by 90 degrees",
    "rotation": "Rotation",
    "rounded": "Rounded",
    "routing": "Routing",
    "routingTabProperties": "Properties",
    "save": "Save",
    "saveAs": "Save as",
    "saved": "Saved",
    "launch": "Launch",
    "scrollbars": "Scrollbars",
    "search": "Search",
    "searchShapes": "Search Shapes",
    "selectAll": "Select All",
    "selectEdges": "Select Routings",
    "selectFont": "Select a Font",
    "selectNone": "Select None",
    "selectParameter": "Select parameter",
    "selectParameters": "Select parameters",
    "selectResponse": "Select response",
    "selectVertices": "Select Tasks",
    "selectWorkQueue": "Select work queue",
    "shadow": "Shadow",
    "shape": "Shape",
    "sharp": "Sharp",
    "sidebarTooltip": "Click to expand. Drag and drop shapes into the diagram. Shift+click to change selection. Alt+click to insert and connect.",
    "simple": "Simple",
    "simpleArrow": "Simple Arrow",
    "size": "Size",
    "solid": "Solid",
    "sourceSpacing": "Source Spacing",
    "south": "South",
    "spacing": "Spacing",
    "start": "Start",
    "task": "User Task",
    "http": "HTTP Task",
    "jq": "JQ Task",
    "testJQFilter": "Test with Input Parameters",
    "wait": "Wait Task",
    "emailTask": "Email Task",
    "mapTask": "Map Task",
    "email": "Email",
    "taskIncomingRouting": "Incoming routing information",
    "taskOutgoingRouting": "Outgoing routing information",
    "taskOutgoingRoute": "{1} to {2}",
    "taskResponses": "Responses",
    "taskTabGeneral": "General",
    "taskTabInputParameters": "Input Parameters",
    "taskTabProcessor": "Task Processor",
    "taskTabHttp": "Configuration",
    "taskTabEmail": "Configuration",
    "taskTabJQ": "JQ Filter",
    "taskTabMap": "Configuration",
    "taskMapItemsExpression": "Map items JSONPath expression",
    "taskMapItemsExpressionHelp": "JSONPath expression selects an array within a JSON input parameters provided to a Map task.",
    "jqFilter": "Expression",
    "httpRequest": "HTTP request",
    "httpRequestTemplate": "HTTP request template",
    "httpRequestTemplateSearch": "Search HTTP request template",
    "testRequest": "Test request",
    "httpResponse": "HTTP response: {1} {2}",
    "taskTabWait": "Configuration",
    "waitSeconds": "Wait for duration in seconds",
    "waitSecondsExpression": "Wait for duration in seconds with expression",
    "waitTimestamp": "Wait until an absolute time",
    "waitTimestampExpression": "Wait until an absolute time with expression",
    "taskTabProcessorHelp": "A task processor provides the information and resources for a participant to complete a task in a workflow. A step processor can also accept input from the participant.",
    "taskConcurrency": "Map task concurrency",
    "taskMaxConcurrency": "Max concurrent tasks",
    "taskMaxConcurrencyHelp": "No limit on concurrent tasks if set to 0.",
    "taskMaxConcurrencyExpression": "Max concurrent tasks with expression",
    "processorPage": "Select a page for step processor",
    "credentialsSelect": "Select a credentials",
    "credentials": "Credentials",
    "credentialsAWS": "AWS",
    "credentialsBEARER_TOKEN": "Bearer Token",
    "credentialsBASIC_AUTHENTICATION": "Basic Authentication",
    "credentialsAPI_KEY": "API Key Header",
    "credentialsOAUTH2": "OAuth 2.0",
    "connectionTimeoutSeconds": "Connection time out in seconds",
    "readTimeoutSeconds": "Read time out in seconds",
    "workflowTimeoutSeconds": "Time out in seconds",
    "workflowTimeoutSecondsHelp": "No time outs if set to 0.",
    "workflowMaxConcurrency": "Max concurrent workflows",
    "workflowMaxConcurrencyHelp": "No limit on concurrent workflows if set to 0.",
    "workflowTabErrorHandling": "Error Handling",
    "workflowTabErrorHandlingHelp": "Workflow to be run on current Workflow failure. Useful for cleanup or post actions on failure.",
    "failureWorkflow": "Workflow definition",
    "failureWorkflowSelect": "Select a workflow definition",
    "failureWorkflowVersion": "Workflow definition version",
    "failureWorkflowVersionSelect": "Latest revision",
    "workflowTabWebhookSettings": "Webhook Settings",
    "workflowTabScheduleTrigger": "Schedule Trigger",
    "workflowTabVariables": "Variables",
    "workflowTabShareSettings": "Share Settings",
    "taskTabRouting": "Routing",
    "taskErrorHandling": "Retry",
    "taskErrorHandlingType": "Retry on errors",
    "taskErrorHandlingNo": "No retry and fail the whole workflow",
    "taskErrorHandlingYes": "Retry the task when errors occur",
    "retryIntervalSeconds": "Interval in seconds",
    "retryIntervalSecondsHelp": "The number of seconds before the first retry attempt.",
    "retryMaxAttempts": "Max attempts",
    "retryMaxAttemptsHelp": "The maximum number of retry attempts.",
    "retryBackoffRate": "Backoff rate",
    "retryBackoffRateHelp": "The multiplier by which the retry interval increases with each attempt.",
    "taskTabWorkflowOutput": "Workflow Output",
    "straight": "Straight",
    "strokeColor": "Line Color",
    "collectorTask": "Collector task",
    "collectorTaskHelp": "Combine the parallel paths into one place.",
    "style": "Style",
    "subscript": "Subscript",
    "superscript": "Superscript",
    "takeRoutesOf": "Take routes of",
    "table": "Table",
    "targetSpacing": "Target Spacing",
    "text": "Text",
    "textAlignment": "Text Alignment",
    "textOpacity": "Text Opacity",
    "toBack": "To Back",
    "toFront": "To Front",
    "tooltips": "Tooltips",
    "top": "Top",
    "topAlign": "Top Align",
    "topLeft": "Top Left",
    "topRight": "Top Right",
    "transparent": "Transparent",
    "turn": "Rotate 90°",
    "uml": "UML",
    "underline": "Underline",
    "undo": "Undo",
    "url": "URL",
    "value": "Value",
    "version": "Version",
    "vertical": "Vertical",
    "verticalFlow": "Vertical Flow",
    "verticalTree": "Vertical Tree",
    "view": "View",
    "waypoints": "Waypoints",
    "west": "West",
    "width": "Width",
    "workflow": "Workflow",
    "workflowTabGeneral": "General",
    "workflowTabWorkflows": "Workflows",
    "workflowTabVersions": "Versions",
    "writingDirection": "Writing Direction",
    "zoom": "Zoom",
    "zoomIn": "Zoom In",
    "zoomOut": "Zoom Out",
    "taskErrors": "There were problems with this task definition",
    "routeErrors": "There were problems with this route definition",
    "subMapErrors": "There were problems within this map definition",
    "subMapExit": "Exit Map: {1}",
    "current": "Current",
    "noVersions": "No versions found for this workflow definition. Publish to create a version.",
    "errorFetchingVersions": "We're unable to fetch workflow definition versions.",
    "errorLoadingEditor": "We're unable to load editor.",
    "pleaseTryAgain": "Please try again",
    "updatedBy": "Last modified by",
    "updatedOn": "Last modified on",
    "actions": "Actions",
    "restore": "Restore",
    "workflowOutput": "Workflow output",
    "workflowOutputHelp": "Workflow output is a JSON fragment with value containing values from input or output of another task during the execution.",
    "taskNameMustBeUnique": "Task definition name already exists. Must be unique within workflow definition.",
    "taskNameMustNotBlank": "Please enter a task definition name",
    "taskIncorrectlyNested": "Route from '{1}' to '{2}' is incorrectly nested.",
    "taskNoCollectorTask": "No collector task found for parallel task '{1}'",
    "openApisSearch": "Search APIs",
    "authorizeCredentials": "Authorize your account with this credentials",
    "reauthorizeCredentials": "Reauthorize your account with this credentials",
    "addWaypoint":"Add Waypoint",
    "removeWaypoint":"Remove Waypoint",
    "clearWaypoints":"Clear Waypoints"
}